/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_RenderingInputs */

const cs_social_export_rendering = /** @type {(inputs: Social_Export_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vykreslování…`)
};

const en_social_export_rendering = /** @type {(inputs: Social_Export_RenderingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering…`)
};

/**
* | output |
* | --- |
* | "Rendering…" |
*
* @param {Social_Export_RenderingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_rendering = /** @type {((inputs?: Social_Export_RenderingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_RenderingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_rendering(inputs)
	return cs_social_export_rendering(inputs)
});